import { createApp } from 'vue';
import store from './store/store.js'
import router from './router.js';
import App from './App.vue';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleRight, faSquareArrowUpRight } from '@fortawesome/free-solid-svg-icons'

library.add(faAngleRight, faSquareArrowUpRight)


const app = createApp(App).component('font-awesome-icon', FontAwesomeIcon);

app.use(store);
app.use(router);
app.mount('#app');